import * as React from 'react';
import {
  eachDayOfInterval,
  endOfMonth,
  endOfWeek,
  format,
  startOfMonth,
  startOfWeek,
} from 'date-fns';
import DaysRow from './DaysRow';
import { DayItem } from '../../../interfaces';

type Props = {
  dayItems: DayItem[];
  selectedMonth: Date;
  selectedDay?: Date;
  setSelectedDay: React.Dispatch<React.SetStateAction<Date>>;
  setDayIsSelected: React.Dispatch<React.SetStateAction<boolean>>;
  disableUnavailable?: boolean;
};

export default function Month({
  dayItems,
  selectedMonth,
  selectedDay,
  setSelectedDay,
  setDayIsSelected,
  disableUnavailable,
}: Props) {
  const weeks = React.useMemo(() => {
    const year = selectedMonth.getFullYear();
    const month = selectedMonth.getMonth();
    const startOfMonthDate = startOfMonth(new Date(year, month));
    const endOfMonthDate = endOfMonth(new Date(year, month));

    const startOfCalendar = startOfWeek(startOfMonthDate);
    const endOfCalendar = endOfWeek(endOfMonthDate);

    const allDates = eachDayOfInterval({
      start: startOfCalendar,
      end: endOfCalendar,
    });

    const tempWeeks: Date[][] = [];
    let week: Date[] = [];

    allDates.forEach(date => {
      week.push(date);
      if (week.length === 7) {
        tempWeeks.push(week);
        week = [];
      }
    });

    return tempWeeks;
  }, [selectedMonth]);

  const rows = React.useMemo<DayItem[][]>(() => {
    const tempRows: DayItem[][] = [];
    for (let i = 0; i < weeks.length; i++) {
      const row = weeks[i].map(date => {
        const dateString = format(date, 'yyyy-MM-dd');
        const dayItem: DayItem = dayItems.find(
          day => dateString === day.date,
        ) ?? {
          date: dateString,
          available: false,
        };
        return dayItem;
      });
      tempRows.push(row);
    }
    return tempRows;
  }, [dayItems, weeks]);

  return (
    <div className="calendar-rows">
      {rows.map(row => (
        <DaysRow
          dayItems={row}
          selectedMonth={selectedMonth}
          selectedDay={selectedDay}
          setSelectedDay={setSelectedDay}
          setDayIsSelected={setDayIsSelected}
          disableUnavailable={disableUnavailable}
          key={row[0].date}
        />
      ))}
    </div>
  );
}
